const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M7.25 11a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75"/><path fill-rule="evenodd" d="M2.25 11a8.75 8.75 0 1 1 15.445 5.634l3.335 3.336a.75.75 0 1 1-1.06 1.06l-3.336-3.335A8.75 8.75 0 0 1 2.25 11M11 3.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5" clip-rule="evenodd"/></svg>';
export {
  a as w
};
